import { ITennisMatchCard } from "@sky-it-livedata/livedata-sports-design-system";
import { MatchCardSubscriptionData } from "../types";
import { ErrorName, WidgetError } from "../../../utils/errors";
// import { UpdateMatchCardWidgetInputSchema } from "cdk/graphql";
import { isValidMatchCardSubscription } from "./typeguards";


export const transformSubscription = (obj: MatchCardSubscriptionData): ITennisMatchCard => {
  if (isValidMatchCardSubscription(obj)) {
    console.log('transformSubscription', obj?.data?.onUpdateMatchCardById);
    //   UpdateMatchCardWidgetInputSchema().parse(obj.data.onUpdateMatchCardById, {reportInput: true});
      const { updatedAt, createdAt, ...matchCardData } = obj?.data?.onUpdateMatchCardById!;

      return {
        ...matchCardData
      } as ITennisMatchCard;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in MatchCardSubscription object',
      data: obj
    });
  }
};
